<template>
    <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-title>
                <h3 class="headline mb-0"><span style="color: #9C1A1A">{{ tipo === 'editar' ? 'Editar Tipo Actuación' : 'Nuevo Tipo Actuación' }}</span></h3>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                <v-layout wrap>

                <v-text-field
                    :disabled="true"
                    ref="code"
                    prepend-icon="code"
                    v-model="form.code"
                    :rules="[v => !!v || 'Codigo es requerido']"
                    label="Codigo"
                    required
                ></v-text-field>
                
                <v-select
                    :disabled="true"
                  v-model="form.personality"
                  prepend-icon="description"
                  :items="personality"
                  :rules="[v => !!v || 'Personalidad es requerido']"
                  item-text="name"
                  item-value="id"
                  label="Personalidad"
                  @change="searchTypeDocuments"
                ></v-select>

                <v-flex xs12>
                    <v-select
                        :disabled="true"
                        :items="documentsType"
                        v-model="form.document_type_father"
                        @change="setPriceDocument"
                        menu-props="auto"
                        label="Tipo de Actuación"
                        prepend-icon="find_in_page"
                        :rules="[v => !!v || 'Tipo de Actuación es requerido']"
                        item-text="padre"
                        item-value="padre_document_type_id"
                    ></v-select>
                </v-flex>
                <!-- <v-flex xs12>
                    <v-select
                        :items="itemChildDocument"
                        v-model="form.document_type"
                        @change="getPriceDocument"
                        menu-props="auto"
                        label="Tipo de Documento"
                        prepend-icon="find_in_page"
                        :rules="[v => !!v || 'Tipo de Documento es requerido']"
                        item-text="document_type_name"
                        item-value="concept_document_type_id"
                    ></v-select>
                </v-flex> -->

                <v-text-field
                    ref="name"
                    prepend-icon="featured_play_list"
                    v-model="form.name"
                    :rules="[v => !!v || 'Nombre es requerido']"
                    label="Nombre"
                    required
                ></v-text-field>

                    <v-flex xs12>
                      <v-menu
                        ref="menu"
                        lazy
                        :close-on-content-click="false"
                        v-model="menu"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-right="40"
                        min-width="290px"
                        :return-value.sync="form.start_date"
                      >
                        <v-text-field
                          slot="activator"
                          label="Fecha de Inicio"
                          v-model="computedDateFormattedFecha"
                          hint="DD/MM/YYYY formato"
                          prepend-icon="event"
                          :rules="[v => !!v || 'Fecha de inicio es requerida']"
                          required
                          readonly
                        ></v-text-field>
                        <v-date-picker v-model="form.start_date" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                          <v-btn flat color="primary" @click="$refs.menu.save(form.start_date)">OK</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>

                <v-flex xs12>
                    <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light" aria-required="true" aria-invalid="false">
                    <div class="v-input__prepend-outer">
                        <div class="v-input__icon v-input__icon--prepend">
                        </div>
                    </div>
                    <div class="v-input__control">
                        <div class="v-input__slot">
                        <div class="v-text-field__slot">
                            <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Monto</label>
                            <vue-numeric currency="BsS" v-model="form.amount" v-bind:precision="2" v-bind:min="0" decimal-separator="," thousand-separator="."></vue-numeric>
                        </div>
                        </div>
                        <div class="v-text-field__details">
                        <div class="v-messages theme--light">
                            <div class="v-messages__wrapper"></div>
                        </div>
                        </div>
                    </div>
                    </div>
                </v-flex>

                <v-flex xs12>
                    <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light" aria-required="true" aria-invalid="false">
                    <div class="v-input__prepend-outer">
                        <div class="v-input__icon v-input__icon--prepend">
                        </div>
                    </div>
                    <div class="v-input__control">
                        <div class="v-input__slot">
                        <div class="v-text-field__slot">
                            <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Monto GG</label>
                            <vue-numeric currency="BsS" v-model="form.gg_amount" v-bind:precision="2" v-bind:min="0" decimal-separator="," thousand-separator="."></vue-numeric>
                        </div>
                        </div>
                        <div class="v-text-field__details">
                        <div class="v-messages theme--light">
                            <div class="v-messages__wrapper"></div>
                        </div>
                        </div>
                    </div>
                    </div>
                </v-flex>
                </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="cerrarDialog(null)">Cerrar</v-btn>
                <v-spacer></v-spacer>
                <v-btn :loading="loading" class="primary" @click="submit">{{ tipo === 'editar' ? 'Actualizar' : 'Crear' }}</v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import axios from 'axios'
import Form from 'vform'
import VueNumeric from 'vue-numeric'

export default {
  name: 'form-role-view',

  props: {

    loading: {
      type: Boolean,
      required: true
    },

    tipo: {
      type: String,
      required: true
    },

    datos: {
      type: Object,
      required: true
    }

  },

  components: {
    VueNumeric
  },

    computed: {
        computedDateFormattedFecha () {
            return this.formatDate(this.form.start_date)
        }
    },

  watch: {
    datos(v) {
      this.$refs.form.resetValidation()
      if (this.tipo == "crear" || this.tipo == "") {
        this.form = {
            id: '',
            document_type_father: '',
            document_type: '',
            cdt_id: '',
            document_type_id: '',
            code: '',
            personality: '',
            name: '',
            amount: '',
            gg_amount: '',
            start_date: ''
        }
      }else if (this.tipo == "editar") {
        var d = new Date(v.start_date).toISOString().slice(0,10);
        v.start_date = d
        Object.assign(this.form, v)
        console.log(v.id)
        this.searchTypeDocuments()
      }
    }
  },

  data: () => ({
    valid: false,
    documentsType: [],
    personality: ['NATURAL','JURIDICA'],
    date: null,
    menu: false,
    form: new Form({
            id: '',
            document_type_father: '',
            document_type: '',
            cdt_id: '',
            document_type_id: '',
            code: '',
            personality: '',
            name: '',
            amount: '',
            gg_amount: '',
            start_date: ''
    }),
    formOld:{
            id: '',
            document_type_father: '',
            document_type: '',
            cdt_id: '',
            document_type_id: '',
            code: '',
            personality: '',
            name: '',
            amount: '',
            gg_amount: '',
            start_date: ''
    }
  }),

  mounted() {
    this.$store.dispatch('clearMessage')
    // this.getDataForm()
  },

  methods: {

    async searchTypeDocuments () {
        this.$emit('loadingResponse', true)
        await axios.post(`/api/sat/search-info-document-type`, { personalidad: this.form.personality })
        .then(resp => {
            this.documentsType = resp.data.documents_type
            this.form.document_type_father = this.form.document_type_id
        })
        this.$nextTick(() => {
            this.$emit('loadingResponse', false)
        })
    },

    async setPriceDocument() {
        this.form.amount = 0
        this.form.gg_amount = 0
    },

    async getChildDocument() {
        this.$emit('loadingResponse', true)
        this.itemChildDocument = this.documentsRequirementsChildSat.filter(drcs => { return drcs.padre_document_type_id == this.form.document_type_father })
        this.$nextTick(() => {
            this.$emit('loadingResponse', false)
        })
    },

    submit () {
      if (this.$refs.form.validate()) {
        this.$emit('responseLoading', true)
        this.submitFormDT()
      }
    },

    formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
    },

    async submitFormDT () {
      try {
        const { data } = await axios.post('/api/document_types/document-types/create-dt', this.form)
        this.cerrarDialog(data)
        this.form = {
            id: '',
            document_type_father: '',
            document_type: '',
            cdt_id: '',
            document_type_id: '',
            code: '',
            personality: '',
            name: '',
            amount: '',
            gg_amount: '',
            start_date: ''
        }
      } catch (e) {
        console.log(e.response, 'data error create')
        this.$emit('responseLoading', false)
        if (e.response.data.errors) {
          this.form.errors.errors = e.response.data.errors
          if (e.response.data.errors.code) {
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: e.response.data.errors.code[0]
            })
          }else if (e.response.data.errors.name) {
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: e.response.data.errors.name[0]
            })
          }
        }else {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            text: e.response.data.error
          })
        }
      }
    },

    cerrarDialog (data) {
      this.$emit('closeDialogDT', data)
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
        this.$emit('responseLoading', false)
     })
    }

  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/FormDocumentType.vue